import { Component } from 'react';
import './App.css';
import AdminPanel from './admin/AdminPanel';
import Login from './login/Login';
import SaveToken from './login/SaveToken';
import { Route, Routes, Navigate } from 'react-router-dom'
import { connect } from 'react-redux'

class App extends Component {
    render() {
        if (this.props.isLoggedIn) {
            return (
                <AdminPanel />
            );
        } else {
            return (    
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/save_token/:token" element={<SaveToken />} />
                    <Route path="*" element={<Navigate to="/login" />} />
                </Routes>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        isLoggedIn: state.auth.isLoggedIn
    }
}

export default connect(mapStateToProps)(App); // connect to redux store
